// extracted by mini-css-extract-plugin
export default {"launcher":"Q_fY","launcher__heading":"Q_fZ","launcher__menu-item":"Q_f0"};